<template>
  <el-container>
    <Menu :activeIndex='activeIndex'></Menu>
    <el-container>
      <el-header>
        <h2>话题管理</h2>
        <el-button size="medium" plain type="success" id='btn_add' @click="dialogBannerVisible = true,clearform()">新增话题</el-button>
      </el-header>
      <el-main>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">

          <el-table-column prop="id" label="ID" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="sort" label="排序" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="img" label="封面" style="">
            <template slot-scope="scope">
              <img :src="scope.row.img" alt="" style="width: 100px;margin-top:5px;">
            </template>
          </el-table-column>
          <el-table-column prop="title" label="名称" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="category" label="分类" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="price" label="价格" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="profile" label="简介" :show-overflow-tooltip="true">
          </el-table-column>



          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row),dialogBannerVisible = true">编辑</el-button>
<!--                <el-button size="mini" plain type="danger" @click="handleDelete(tableData, scope.row,scope.$index)">删除</el-button>-->
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>Copyright &copy; Soren经济学人 技术支持 ：
        <a href="#">苏州西西弗斯商务信息咨询有限公司</a>
      </el-footer>
    </el-container>
    <el-dialog title="话题编辑" :visible.sync="dialogBannerVisible">

      <el-form :model="form">
        <el-form-item label="ID" :label-width="formLabelWidth">
          <el-input v-model="form.id" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="发布" :label-width="formLabelWidth">
          <el-switch v-model="form.fabu" active-color="blue" inactive-color="red" active-text="发布" active-value="1" inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="封面图" :label-width="formLabelWidth">
          <el-upload class="avatar-uploader" :action="UploadUrl()" :http-request='submitLogoUpload' :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="form.img" :src="form.img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类序号ID,英文逗号分割" :label-width="formLabelWidth">
          <el-input v-model="form.category" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="价格" :label-width="formLabelWidth">
          <el-input v-model="form.price" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth">
          <vue-editor v-model="form.profile"  :editorToolbar="customToolbar"></vue-editor>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBannerVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogBannerVisible = false,submitbanner(form)">确 定</el-button>
        <el-button type="success" @click="dialogTopicVisible = true,editorLesson(form)">编辑课时</el-button>
      </div>
    </el-dialog>
    <el-dialog title="课时编辑" :visible.sync="dialogCourseVisible">
      <div v-if="dialogCourseVisible">
        <el-checkbox v-for="(item,index) in selectLessons" :key="index" v-model="selectLesson" disabled>{{item.title}}</el-checkbox>
      </div>
      <el-divider></el-divider>
      <el-col :span="12">
        <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        选择课程<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
          <el-dropdown-menu slot="dropdown" class="dropdown-max">
            <el-dropdown-item v-for="(item,index) in allLessons" :key="index" :command="item.id" icon="el-icon-plus">{{item.courseName}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <div v-if="dialogLessonVisible">
        <el-checkbox v-for="(item,index) in showLessons" :key="index"  @change="checkBoxChange(item)">{{item.title}}</el-checkbox>
      </div>
      <el-divider></el-divider>
      <el-button @click="dialogCourseVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogBannerVisible = false,insertLesson()">确 定</el-button>
    </el-dialog>
  </el-container>

</template>

<script>
//import tinyMce from "./tinymce.vue";
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      activeIndex: "13",
      tableData: [],
      formLabelWidth: "150px",
      dialogBannerVisible: false,
      dialogTopicVisible : false,
      dialogCourseVisible : false,
      dialogLessonVisible : false,
      dialogSelectLessonVisible : false,
      selectLesson : true,
      form: {
        id : '',
        mark: localStorage.getItem("mark"),
        sort: "",
        category : "",
        img: "",
        title: "",
        price: "",
        profile : "",
        fabu : 1
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike","blockquote"],
        ["image",'link','video'],
        [{'list': 'ordered'}, {'list': 'bullet' }, {'list': 'check' }],
        [{
          color: []
        }, {
          background: []
        }],
        [{
          font: []
        }],
        [{
          align: []
        }],
        [{
          header: 1
        }, {
          header: 2
        }],
        [{
          header: [1, 2, 3, 4, 5, 6, false]
        }],
        [{
          size: ["small", false, "large", "huge"]
        }]
      ],
      topicId : '',
      selectLessons : [],
      allLessons : [],
      showLessons: [],
      selectedLessons :[],
      requestUrl : 'https://soren.guanqimiao.cn',  //正式上线后改为 https://soren.guanqimiao.cn
    };
  },
  components: {
    VueEditor
  },
  created() {
    this.getData();
  },
  updated: function() {
    this.ifHavemark();
  },
  mounted() {
    this.getAllLesson();
  },
  methods: {
    // 页面 表格数据 初始化
    getData() {
      let self = this;
      let url = self.requestUrl + '/Topic/getAllTopic';
      self.axios.post(url,{
        mark: localStorage.getItem("mark")
      })
        .then(function(response) {
          if(response.data.code == "600") {} else if(response.data.code == "400") {
            self.$message({
              type: "error",
              message: "操作失败"
            });
          } else {
            self.tableData = response.data;
          }
          ////console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    UploadUrl: function() {
      return "https://console.sorenenglish.com/file/uploadLogo";
    },
    submitLogoUpload(content) {
      var self = this;
      //1. 创建formData 利用AXIOS传递
      let formData = new FormData();
      formData.append("file", content.file);
      let config = {
        "Content-Type": "multipart/form-data"
      };
      let var_this = this;
      self.axios.post("/file/uploadLogo", formData, config)
        .then(function(response) {
          //console.log(response);
          self.form.img = response.data.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //form 表单 数据
    submitbanner(formName) {
      let self = this;
      let url = self.requestUrl +  '/Topic/editorTopic';
      self.axios.post(url,formName)
        .then(function(response) {
          console.log(response);
          if(response.status === 200){
            self.$message({
              message: response.data,
              type: "success"
            });
            self.getData();
          }else{
            self.$message({
              message: response.data,
              type: "fail"
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    editorLesson(form){
      let self = this;
      self.showLessons = [];
      self.dialogCourseVisible = true;
      self.dialogSelectLessonVisible = true;
      self.topicId = form.id;
      self.getDatalessons(self.topicId);
    },
    submitLesson(form){
      let self = this;
      self.topicId = form.id;
      self.getDatalessons(self.topicId);
    },
    getDatalessons(topicId) {
      let self = this;
      let url = self.requestUrl + '/Topic/queryTopicLesson';
      self.axios.post(url, {
        topicId: topicId
      })
        .then(function(response) {
          self.selectLessons = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAllLesson(){
      let self = this;
      let url = self.requestUrl + '/Topic/getAllLesson';
      self.axios.post(url, {
      })
        .then(function(response) {
          self.allLessons = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handleCommand(command) {  //点击了具体课程
      this.$message('click on item ' + command);
      let self = this;
      self.showLessons = [];
      self.dialogLessonVisible = true;
      let url = self.requestUrl + '/Topic/queryTopicLessonByCourseId';
      self.axios.post(url, {
        topicId: self.topicId,
        courseId:command
      })
        .then(function(response) {
          self.showLessons = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });

    },
    checkBoxChange(e){
      let that = this;
      if(that.selectedLessons.includes(e)){
        let tempIndex = 0;
        that.selectedLessons.forEach((item,index) => {
          if(item === e){
            tempIndex = index
          }
        })
        that.selectedLessons.splice(tempIndex,1);
      }else{
        that.selectedLessons.push(e);
      }
    },
    insertLesson(){
      let self = this;
      let url = self.requestUrl + '/Topic/editorTopicLesson';
      self.axios.post(url, {
        topicId: self.topicId,
        lessons: self.selectedLessons
      })
        .then(function(response) {
          self.$message({
            type: "success",
            message: response.data
          });
          self.dialogCourseVisible = false;
          self.showLessons = [];
          self.selectedLessons = [];
        })
        .catch(function(error) {
          self.$message({
            type: "error",
            message: error
          });
        });
    },
    clearform() {
      let self = this;
      self.form.id = "";
      self.form.fabu = "";
      self.form.sort = "";
      self.form.img = "";
      self.form.id = "";
      self.form.price = "";
      self.form.title = "";
      self.form.profile = "";
    },
    handleEdit(index, row) {
      var self = this;
      self.form.id = row.id;
      self.form.sort = row.sort;
      self.form.fabu = row.fabu;
      self.form.img = row.img;
      self.form.id = row.id;
      self.form.title = row.title;
      self.form.price = row.price;
      self.form.profile = row.profile;
      self.form.category = row.category;
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.form.src = res.data;
    },
    beforeAvatarUpload: function(file) {
      var that = this;
      const isJPG = file.type === 'image/jpeg';
      const isGIF = file.type === 'image/gif';
      const isPNG = file.type === 'image/png';
      const isBMP = file.type === 'image/bmp';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if(!isJPG && !isGIF && !isPNG && !isBMP) {
        that.$message({
          message: '上传图片必须是JPG/GIF/PNG/BMP 格式!',
          type: 'warning'
        });
      }
      if(!isLt2M) {
        that.$message({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning'
        });
      }
      return(isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.dropdown-max{
  top: 150px !important;
  max-width: 600px;
  display: flex;
  flex-flow: row wrap;
}
.dropdown-max li{
  margin-right: 5px;
  white-space: nowrap;
}



.el-header {
  position: relative;
}

.el-header h2 {
  margin: 0;
  line-height: 60px;
}

.el-header #btn_add {
  position: absolute;
  right: 25px;
  top: 12px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #67c23a;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.avatar {
  width: 100%;
  height: auto;
  display: block;
}

.Saveid {
  cursor: pointer;
  color: #67c23a;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Topic.vue